<script setup lang="ts">
defineProps<{ contractId: string | number; flowType: 'client' | 'owner' }>()
const { t } = useI18n()
</script>

<template>
  <div class="flex size-full flex-col items-center gap-4 px-6 text-gray-700">
    <h1 class="m-0 text-xl font-bold">
      {{ t(`${flowType}.title`) }}
    </h1>

    <p>{{ t(`${flowType}.text`) }}</p>

    <BaseButton
      block-full
      color="secondary"
      size="lg"
      variant="btn"
      :to="`https://lecollectionist.onelink.me/coqN?af_xp=custom&pid=my_media_source&af_dp=lecollectionistowners%3A%2F%2F&af_force_deeplink=true&contractId=${contractId}&type=clientContract`"
    >
      {{ t('cta') }}
    </BaseButton>

    <BaseNuxtImg
      :alt="t('alt')"
      class="my-4"
      src="production/assets/images/reservation-agreement/collectionist-mobile.png"
      height="315"
      width="342"
    />

    <p v-if="flowType === 'client'">{{ t('client.moreInfo') }}</p>
  </div>
</template>

<i18n lang="yaml">
en:
  alt: Dowload the mobile application,
  cta: Continue on the app
  client:
    title: Confirm your booking from the application
    text: For a better experience, please continue the booking confirmation process from the application.
    moreInfo: Through the application, you will also be able to access the details of your booking and the itinerary of your stay.
  owner:
    title: Confirm the booking from the application
    text: For a better experience, please continue the booking confirmation process from the application
fr:
  alt: Télécharger l'application mobile
  cta: Continuer sur l’application
  client:
    title: Confirmez votre réservation depuis l'application
    text: Pour une meilleure expérience, veuillez poursuivre le processus de confirmation de votre réservation depuis l'application.
    moreInfo: Grâce à l'application, vous pourrez également accéder aux détails de votre réservation et au programme de votre séjour.
  owner:
    title: Valider la réservation depuis l'application
    text: Pour une meilleure expérience, veuillez poursuivre le processus de validation de la réservation depuis l'application
</i18n>
